module.exports = __webpack_public_path__ + "static/media/Arrow-Circle-Close-Disabled.9a341c9d.svg";